export default function Products() {
  return (
    <section id="products" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-gray-500 text-sm font-light mb-3 tracking-wide">Our Solutions</p>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900">
            VPN & Cleaner<br />
            <span className="italic font-light">Applications</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-gradient-to-br from-rose-100 to-rose-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
            <div className="aspect-[3/4] relative">
              <img
                src="https://public.readdy.ai/ai/img_res/cd69cd1ed57fd0e845b7da2b40f0dc5c.jpg"
                alt="VPN Application"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-white p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">VPN Pro</h3>
              <p className="text-sm text-gray-600">Secure and fast VPN connection for iOS devices</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-emerald-100 to-emerald-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
            <div className="aspect-[3/4] relative">
              <img
                src="https://readdy.ai/api/search-image?query=iOS%20device%20cleaner%20application%20interface%20displaying%20storage%20optimization%20screen%20with%20circular%20progress%20indicator%20and%20clean%20now%20button%20on%20iPhone%20mockup%20modern%20minimalist%20UI%20design%20with%20soft%20colors%20professional%20mobile%20app%20screenshot%20simple%20clean%20background&width=400&height=600&seq=prod-cleaner-001&orientation=portrait"
                alt="Cleaner Application"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-white p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">Device Cleaner</h3>
              <p className="text-sm text-gray-600">Optimize storage and boost device performance</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-violet-100 to-violet-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
            <div className="aspect-[3/4] relative">
              <img
                src="https://readdy.ai/api/search-image?query=iOS%20security%20application%20interface%20showing%20privacy%20protection%20dashboard%20with%20lock%20icons%20and%20security%20status%20on%20iPhone%20mockup%20elegant%20minimalist%20design%20with%20gradient%20background%20professional%20mobile%20app%20UI%20screenshot%20clean%20simple%20layout&width=400&height=600&seq=prod-security-001&orientation=portrait"
                alt="Security Features"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-white p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">Privacy Shield</h3>
              <p className="text-sm text-gray-600">Advanced privacy protection for your data</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-amber-100 to-amber-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
            <div className="aspect-[3/4] relative">
              <img
                src="https://readdy.ai/api/search-image?query=iOS%20performance%20optimizer%20application%20interface%20displaying%20speed%20boost%20screen%20with%20speedometer%20gauge%20and%20optimize%20button%20on%20iPhone%20mockup%20modern%20clean%20UI%20design%20with%20warm%20colors%20professional%20mobile%20app%20screenshot%20minimalist%20simple%20background&width=400&height=600&seq=prod-optimizer-001&orientation=portrait"
                alt="Performance Optimizer"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-white p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">Speed Optimizer</h3>
              <p className="text-sm text-gray-600">Enhance device speed and responsiveness</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}